// Shared article-body rendering for ArticleModal and StoryPage.
// Handles **bold** markdown and <callout> blocks without innerHTML (no XSS).

const renderBold = (text) => {
  const segments = text.split(/\*\*(.*?)\*\*/g);
  return segments.map((seg, i) =>
    i % 2 === 1 ? <strong key={i}>{seg}</strong> : seg
  );
};

export const renderArticleBody = (body) => {
  if (!body) return null;

  const parts = body.split(/<callout>([\s\S]*?)<\/callout>/gi);

  return parts.map((part, index) => {
    if (index % 2 === 1) {
      return (
        <div key={index} className="callout">
          <span>{renderBold(part)}</span>
        </div>
      );
    }

    const paragraphs = part.split('\n\n').filter(p => p.trim());
    return paragraphs.map((p, pIndex) => (
      <p key={`${index}-${pIndex}`} className="mb-3.5">
        {p}
      </p>
    ));
  });
};
